<ng-template [ngIf]="!showCreate">
  <!-- START PAGE CONTENT-->
  <div style="margin-bottom:20px;" fade-in-up>
    <!--div class="heading-out d-flex justify-content-between">
      <h5 id="brand-card-header">BrandCard STATISTICS</h5>

      <div class="d-inline-block">
        <!-- a routerLink="./" fragment="post-card-header" class="btn btn-link mh-3">GO TO PostCard STATISTICS</a>
        <select (change)="switchBranch($event)" class="form-control-solid">
          <option [value]="i" *ngFor="let i of branches">{{i}}</option>
        </select->
      </div>
    </div-->

    <div class="page-heading">
      <div class="page-title">Dashboard</div>
    </div>

    <div class="statistics-page row">
      <div class="col-lg-9">
        <div class="ibox">
          <div class="ibox-body">
            <app-brand-card-analytics-widget></app-brand-card-analytics-widget>
          </div>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="ibox">
          <div class="ibox-body top-stats">
            <div class="widget-wrapper">
              <h2 class="blue-font mb-1">{{total.exchange}}</h2>
              <div class="">TODAY'S EXCHANGE</div>
              <!--i class="fa fa-exchange widget-stat-icon text-zeroblue"></i-->
              <!--div class="mt-1">
                <span class="font-13 mr-1">
                  <! i class="fa fa-level-{{statistic?.todayExchange.diffPercentage > 0 ? 'up' : 'down'}}"></i>
                  {{statistic?.todayExchange.diffPercentage}}%</span><small>than last week</small->
                  {{total.exchange}}  </span>
              </div-->
            </div>

            <div class="widget-wrapper mt-5">
              <h2 class="blue-font mb-1">{{total.connect}}</h2>
              <div class="">CONNECTIONS MADE</div>
              <!--i class="fa fa-link widget-stat-icon text-zeroblue"></i-->
              <!--div class="mt-1">
                <span class="font-13 mr-1"><!-
                    class="fa fa-level-{{statistic?.connectionsMade.diffPercentage > 0 ? 'up' : 'down'}}"></i>
                  {{statistic?.connectionsMade.diffPercentage}}%</span><small>than last week</small ->
                  {{total.connect}} </span>
              </div-->
            </div>

            <div class="widget-wrapper mt-5">
              <h2 class="blue-font mb-1"> {{totalnetwork}} </h2>
              <div class="">TOTAL NETWORKS</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="statistics-page">
      <div class="ibox">
        <div class="ibox-body">
          <div class="row">
            <div class="col-lg-6">
              <div class="">
                <div class="flexbody network-detail-stats">
                  <div class="widget-wrapper text-center">
                    <div>BrandCard Network</div>
                    <h2 class="blue-font" style="margin-bottom:0px">{{ total.network }}</h2>
                  </div>
                  <div class="widget-wrapper text-center">
                    <div>Non-ZERO Network</div>
                    <h2 class="blue-font" style="margin-bottom:0px">{{ total.nonzero }}</h2>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="">
                <div class="flexbody wc-bc-stats">
                  <div class="widget-wrapper text-center">
                    <div>Total WhiteCards</div>
                    <h2 class="blue-font" style="margin-bottom:0px">{{total2.wc}}</h2>
                  </div>
                  <div class="widget-wrapper text-center">
                    <div>Total BlackCards</div>
                    <h2 class="blue-font" style="margin-bottom:0px">{{total2.bc}}</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="statistics-page row">
      <!--div class="col-xl-4">
        <div class="ibox">
          <div class="ibox-head">
            <div class="ibox-title">TOP PERFORMERS</div>
          </div>
          <div class="ibox-body">
            <app-top-performers></app-top-performers>
          </div>
        </div>
      </div-->

      <div class="col-md-4">
        <div class="ibox top-industry">
          <div class="ibox-head">
            <div class="ibox-title">TOP INDUSTRY</div>
          </div>
          <div class="ibox-body">
            <div class="mt-2 mb-2 d-flex justify-content-between" *ngFor="let x of topindustry">
              <div>{{x.comp_ins}}</div>
              <div class="top-industry-num blue-font align-items-right"><b>{{x.total}}</b></div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="ibox">
          <div class="ibox-head">
            <div class="ibox-title">TOP DEPARTMENTS</div>
          </div>
          <div class="ibox-body">
            <app-top-departments></app-top-departments>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="ibox">
          <div class="ibox-head">
            <div class="ibox-title">
              WHO'S WORKING HARD
              <!-- div class="ibox-subtitle">Based on last 1000 exchanges</div -->
            </div>
          </div>
          <div class="ibox-body">
            <!-- app-trending></app-trending -->
            <app-top-performers></app-top-performers>
          </div>
        </div>
      </div>
    </div>

    <div class="statistics-page row">
      <div class="col-xl-12">
        <div class="ibox">
          <div class="ibox-head">
            <div class="ibox-title">NEW CONNECTS</div>
          </div>
          <div class="ibox-body">
            <app-new-connect></app-new-connect>
          </div>
        </div>
      </div>
    </div>

    <div class="statistics-page">
      <div class="ibox">
        <div class="ibox-head">
          <div class="ibox-title">ACTIVITIES</div>
        </div>
        <div class="ibox-body">
          <ul class="timeline scroller" data-height="360px">
            <!-- li *ngFor="let activity of statistic?.recentActivities" class="timeline-item">
              <span class="timeline-point"
                [ngClass]="{'bg-warning': activity.type === 'connection', 'bg-primary': activity.type === 'echo', 'bg-secondary': activity.type ==='share'}"></span>
              {{ activity.text }}<small
                class="float-right text-muted ml-2 nowrap">{{activity.timestamp | timeago}}</small>
            </li -->
            <li *ngFor="let x of activity" class="timeline-item">
              <div class="timeline-point" [ngClass]="{'bg-warning': activity.type === 'connection', 'bg-primary': activity.type === 'echo', 'bg-secondary': activity.type ==='share'}"></div>
              <div class="activity-details"><b>{{x.email}}</b> {{ x.action }}</div>
              <small class="text-muted nowrap">{{parseDate(x.hcreated_at) | timeago:false}}</small>
            </li>
          </ul>
          <a routerLink="/activities">More</a>
        </div>
      </div>
    </div>
  </div>


  <ng-template *ngIf="postdev">
    <div class="heading-out d-flex justify-content-between">
      <h5 id="post-card-header">PostCard STATISTICS</h5>

      <div class="d-inline-block">
        <a routerLink="./" fragment="brand-card-header" class="btn btn-link mh-3">GO TO BrandCard STATISTICS</a>

        <select (change)="switchBranch($event)" class="form-control-solid">
          <option [value]="i" *ngFor="let i of branches">{{i}}</option>
        </select>
      </div>
    </div>

    <!-- TODO: Get post cards statistic -->
    <div class="row">
      <div class="col-xl-12">
        <div class="ibox">
          <div class="ibox-head">
            <div class="ibox-title">Most Recent</div>
          </div>
          <div class="ibox-body">
            <app-recent-post-cards></app-recent-post-cards>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-12">
        <div class="ibox">
          <div class="ibox-head d-flex justify-content-between">
            <div class="ibox-title">Most Shared</div>
            <div>Total <h2 class="text-success d-inline">5200</h2> Shares</div>
          </div>
          <div class="ibox-body">
            <app-recent-post-cards></app-recent-post-cards>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-12">
        <div class="ibox">
          <div class="ibox-head d-flex justify-content-between">
            <div class="ibox-title">Most Viewed</div>
            <div>Total <h2 class="text-success d-inline">5200</h2> Views</div>
          </div>
          <div class="ibox-body">
            <app-recent-post-cards></app-recent-post-cards>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-12">
        <div class="ibox">
          <div class="ibox-head d-flex justify-content-between">
            <div class="ibox-title">Most Likes</div>
            <div>Total <h2 class="text-success d-inline">5200</h2> Likes</div>
          </div>
          <div class="ibox-body">
            <app-recent-post-cards></app-recent-post-cards>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-12">
        <div class="ibox">
          <div class="ibox-head d-flex justify-content-between">
            <div class="ibox-title">Most Comments</div>
            <div>Total <h2 class="text-success d-inline">5200</h2> Comments</div>
          </div>
          <div class="ibox-body">
            <app-recent-post-cards></app-recent-post-cards>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <!-- END PAGE CONTENT-->
</ng-template>


<ng-template [ngIf]="showCreate">
  <div class="empty-page-section fade-in-up">
    <div class="content-title">Welcome to <b>ZERO</b> Brand<b>Card</b>™</div>
    <div class="empty-page-content ibox">
      <div>This is where you register your company in the <b>ZERO</b> Brand<b>Card</b>™ platform, design your company Com<b>Card</b>, and distribute Black<b>Card</b>s to all your employees.</div>
      <br />
      <div class="blue-font">Let's get started.</div>
      <br />
      <button class="btn" (click)="regcomp()"><b>REGISTER A COMPANY</b></button>
    </div>
  </div>
</ng-template>
